import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgEmailNotification(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.952 52.863a6 6 0 0 1 3.407-4.688l31.888-14.948a12 12 0 0 1 10.76.288l26.355 14.12a6 6 0 0 1 3.12 6.032l-5.134 41.077A6 6 0 0 1 88.394 100H24.857a6 6 0 0 1-5.954-6.744l5.05-40.393Z"
        fill="#42A486"
      />
      <path
        d="m65.565 75.177 30.621-16.493a6.303 6.303 0 0 0 3.265-4.767l1.844-12.29.006-.043a6.304 6.304 0 0 0-3.278-6.338L72.118 21.37a12.605 12.605 0 0 0-11.302-.302L29.354 35.814a6.303 6.303 0 0 0-3.579 4.925l-1.843 12.29c-.31 2.48.87 4.942 3.016 6.224L53.12 74.9a12.605 12.605 0 0 0 12.445.278Z"
        fill="#00664F"
      />
      <path
        d="M33.554 39.077a2.4 2.4 0 0 1 2.381-2.103h55.717a1.8 1.8 0 0 1 1.786 2.024l-5.393 43.141a6 6 0 0 1-5.953 5.256H34.31a6 6 0 0 1-5.954-6.744l5.197-41.574Z"
        fill="#F1F5F9"
      />
      <path
        d="M54.349 69.367a12.605 12.605 0 0 0 12.445.278l24.46-13.174-3.209 25.667a6 6 0 0 1-5.953 5.256H34.311a6 6 0 0 1-5.953-6.744l3.119-24.956 22.872 13.673Z"
        fill="#CCD5E1"
      />
      <path
        d="M24.857 100h63.537a6 6 0 0 0 5.954-5.256l5.103-40.819a6.303 6.303 0 0 1-3.265 4.76L65.565 75.178A12.605 12.605 0 0 1 53.12 74.9L26.948 59.254c-2.146-1.283-3.326-3.744-3.016-6.224l-5.029 40.226A6 6 0 0 0 24.857 100Z"
        fill="#80CCB5"
      />
      <path
        d="M24.857 100h63.537a6 6 0 0 0 5.954-5.256l5.103-40.819a6.303 6.303 0 0 1-3.265 4.76L65.565 75.178A12.605 12.605 0 0 1 53.12 74.9L26.948 59.254c-2.146-1.283-3.326-3.744-3.016-6.224l-5.029 40.226A6 6 0 0 0 24.857 100Z"
        fill="#78B441"
      />
      <path
        d="M88.127 100H25.2c-3.791 0-6.725-3.323-6.254-7.085l.003-.03a5.261 5.261 0 0 1 2.272-3.676l26.211-17.71 5.688 3.4a12.605 12.605 0 0 0 12.445.278l6.066-3.267L91.78 88.066a7.093 7.093 0 0 1 2.6 6.413 6.35 6.35 0 0 1-.451 1.683 6.305 6.305 0 0 1-5.802 3.837Z"
        fill="#599F40"
      />
      <path
        d="M25.2 100h62.927a6.302 6.302 0 0 0 6.254-5.52 6.075 6.075 0 0 0-2.91-5.968L64.874 72.614a12 12 0 0 0-11.847-.265L21.345 89.413a4.63 4.63 0 0 0-2.4 3.503C18.476 96.678 21.409 100 25.2 100Z"
        fill="#78B441"
      />
      <path
        d="M17.742 37.73a.8.8 0 0 1 .983-.56l1.922.526a.8.8 0 1 1-.422 1.542l-1.923-.526a.8.8 0 0 1-.56-.983Zm4.217-8.824a.8.8 0 0 1 1.128.1l2.025 2.414a.8.8 0 0 1-1.227 1.028l-2.025-2.415a.8.8 0 0 1 .1-1.127Zm7.931.84-.103-1.887a.8.8 0 0 1 1.599-.087l.102 1.888a.8.8 0 0 1-1.598.087ZM109.92 40.842a.8.8 0 0 0-.826-.773l-1.991.065a.8.8 0 1 0 .052 1.6l1.992-.066a.8.8 0 0 0 .773-.826Zm-.844-9.202a.8.8 0 0 0-1.119-.166l-2.531 1.879a.8.8 0 0 0 .953 1.284l2.53-1.878a.8.8 0 0 0 .167-1.119Zm-10.081-.355.538-1.812A.8.8 0 1 0 98 29.017l-.538 1.813a.8.8 0 1 0 1.533.455Z"
        fill="#0F172A"
      />
      <path
        d="M68.346 54.008a7.088 7.088 0 0 0-14.043-1.932l-.966 7.021L67.38 61.03l.966-7.022Z"
        fill="#78B441"
      />
      <path
        d="M60.147 46.027a1.905 1.905 0 1 0 3.774.52 1.905 1.905 0 0 0-3.774-.52ZM57.589 61.883a2.726 2.726 0 1 0 5.4.744 2.726 2.726 0 0 0-5.4-.744Z"
        fill="#78B441"
      />
      <path
        d="M60.66 59.554a2.726 2.726 0 0 1 2.201 3.605l-5.165-.06a2.726 2.726 0 0 1 2.964-3.545Z"
        fill="#599F40"
      />
      <path
        d="M67.55 49.655a7.053 7.053 0 0 1 .796 4.353l-.966 7.022-14.043-1.933.189-1.375c.337.053.685.105 1.044.154 5.825.796 11.24-2.78 12.98-8.22Z"
        fill="#599F40"
      />
      <path
        d="M54.045 47.637a2.726 2.726 0 1 0 5.402.743 2.726 2.726 0 0 0-5.402-.743Z"
        fill="#FC0"
      />
      <path
        d="M51.923 59.029a2.1 2.1 0 0 1 2.365-1.797l13.078 1.787a2.1 2.1 0 0 1-.568 4.161l-13.079-1.786a2.1 2.1 0 0 1-1.796-2.365Z"
        fill="#78B441"
      />
      <path
        d="M67.367 59.019a2.1 2.1 0 0 1-.569 4.161l-2.378-.325a2.1 2.1 0 0 0 .568-4.16l2.379.324Z"
        fill="#599F40"
      />
      <path
        d="M56.936 57.026a.36.36 0 0 0-.098.714l10.802 1.486a.36.36 0 0 0 .099-.714l-10.803-1.486Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgEmailNotification)
